import { Contratos } from "../../class/contratos";
import { Cliente } from "../../class/clientes";
export default {
    data() {
        return {
            user: null,
            cliente: {}
        };
    },
    computed: {
        contrato() {
            return this.$store.state.contrato;
        },
        contrato_id: function() {
            return this.$route.params.id;
        }
    },
    methods: {
        loadContrato() {
            if (this.$route.params.id) {
                // this.$store.dispatch('getContratos', this.$route.params.id);
                Contratos.byID(this.$route.params.id)
                    .then(row => {
                        this.$store.commit("setContrato", row);
                        this.loadCliente(row.cliente._id);
                    })
                    .catch(err => console.log(err));
            }
        },
        async loadCliente(clienteId) {
            let row = await Cliente.byID(clienteId);
            let cont = this.contrato;
            cont.cliente = {};
            cont.cliente.nome = row.nome;
            cont.cliente.cliente_id = row._id;
            this.$store.commit("setContrato", cont);
            this.$store.commit("setCliente", row);
        },
        loadContratoByRef() {
            if (this.$route.params.ref_id) {
                Contratos.byRef(this.$route.params.ref_id)
                    .then(row => {
                        this.contrato = row;
                        this.loadCliente(row.cliente._id);
                    })
                    .catch(err => console.log(err));
            }
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.loadContrato(this.$route.params.id);
        } else if (this.$route.params.ref_id) {
            this.loadContratoByRef(this.$route.params.ref_id);
        } else if (this.$route.params.cliente_id) {
            this.$store.commit("setContrato", Contratos.create());
            this.loadCliente(this.$route.params._id);
        }
    }
};
